import { Transform } from 'engine/Transform';
import { V2, addV2 } from 'engine/lib/V2';
import { create } from 'engine/lib/create';
import { FranklinEntity } from '../tent-int/Franklin';
import { CotEntity, TentFlapEntity, TentIntEntity } from '../tent-int/TentIntEntity';

interface TentMapProps {
  offset: V2,
  onExit: () => void,
  onTalk: () => void,
}

export const createTent = ({ offset, onExit, onTalk }: TentMapProps) => {
  const entities = {
    tent: {
      entity: create(TentIntEntity, {}),
      config: { transform: new Transform({ position: [0, 0] }) },
    },
    cot: {
      entity: create(CotEntity, {}),
      config: { transform: new Transform({ position: [85, 564] }) },
    },
    franklin: {
      entity: create(FranklinEntity, { onTalk }),
      config: { transform: new Transform({ position: [464, 329] }) },
    },
    flap: {
      entity: create(TentFlapEntity, { onExit }),
      config: { transform: new Transform({ position: [260, 706] }) },
    },
  };

  Object.values(entities).forEach(({ config }) => {
    addV2(config.transform.position, offset);
  });

  return entities;
};
